<template>
  <v-card>
    <v-toolbar card color="success" dark>
      <v-toolbar-title class="body-2">PAGO</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close-payment')" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-layout row wrap>
          <v-flex lg12 sm12>
            <upload-btn @clicked="onFilePicked"></upload-btn>
            <div v-if="form.files == null" class="v-text-field__details">
              <div class="v-messages theme--light error--text">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">El archivo es requerido</div>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn @click="handleSave" color="success">Salvar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UploadButton from './FileUpload'

export default {
  components: {
    'upload-btn': UploadButton,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    form: {
      invoices: [],
      files: '',
    },
  }),
  created() {
    this.form = { ...this.item }
  },
  methods: {
    onFilePicked(files) {
      this.form.files = files
    },
    handleSave() {
      this.$validator.validateAll().then(result => {
        if (result && this.form.files) {
          this.$store.dispatch('transit/payInvoice', this.form).then(() => {
            this.$emit('save-payment')
          })
        }
      })
    },
  },
}
</script>
